











































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import {
  PartnersApi, DocumentRequest, Partner, PartnerOnboarding,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import PartnerUtil from '@/util/PartnerUtil';
import FileUploadForm from '@/components/Form/FileUploadForm/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import LifecycleModule from '@/store/modules/lifecycle';

@Component({
  components: {
    FileUploadForm,
    PrimaryButton,
  },
  directives: { Sticky },
})
export default class ApplicationForms extends Vue {
  public documents: Array<DocumentRequest> | null = null;

  public saving: boolean = false;

  public mounted() {
    this.getDocuments();
  }

  get loading() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return false;
    }
    return true;
  }

  @Watch('loading')
  onLoadChanged(val: boolean) {
    if (val === false) {
      this.getDocuments();
    }
  }

  public async getDocuments() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      try {
        const partnerId = UserModule.currentPartner.id;
        const api = new PartnersApi(AppModule.apiConfig);
        const docs = await api.getPartnerDocuments(partnerId);
        const { documents } = docs.data;
        ((this.documents) as any) = documents;
      } catch {
        this.documents = [];
      }
    }
  }

  public async confirmation() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      this.saving = true;
      try {
        const partnerID = UserModule.currentPartner.id;
        const onBoardStaus: string = 'awaitScout';
        const data: any = {
          status: onBoardStaus,
        };
        const api = new PartnersApi(AppModule.apiConfig);
        const partners = await api.updatesPartnerOnboarding(partnerID, data);
        const { onboarding } = partners.data;
        const { status }: any = onboarding;
        await AppModule.fetchPartnerInfo((UserModule.currentUser as any).id as string);
        if (status === 'awaitScout') {
          const userID: any = partners.data.id;
          this.$router.push({ name: 'home', params: { userID } });
        }
      } catch (error) {
        console.log('err', error);
      }
    }
    this.saving = false;
  }

  public back() {
    this.$router.push('/application/detail_forms');
  }

  get partnerID() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return UserModule.currentPartner.id;
    }
    return '';
  }

  public logout() {
    LifecycleModule.terminate();
    this.$router.push('/login');
  }
}
